import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsPersonFill } from "react-icons/bs";
import { BASE_URL, USER_URL } from "../../constant/api";
import { Link, useParams } from "react-router-dom";
import img from "../../assets/seller/loading.png";

function SubAdminSellerView() {
  const [sellerData, setSellerData] = useState({});
  const [sellerProducts, setSellerProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { Id } = useParams();

  useEffect(() => {
    const fetchSellerData = async () => {
      try {
        const response = await USER_URL.get(`/accounts/subadmin/companies/${Id}/`);
        console.log(response);
        
        setSellerData(response.data?.data.company_details || {});
        setSellerProducts(response.data?.data.products    || []);
      } catch (error) {
        console.error("Error fetching seller data:", error.message || error);
        setSellerData({});
      } finally {
        setLoading(false);
      }
    };

   

    fetchSellerData();
    
  }, [Id]);console.log(sellerProducts);
  

  if (loading) {
    return <div className="text-center mt-10 text-green-500">Loading seller data...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h1 className="mb-5 text-green-500 font-semibold">{sellerData.name || "N/A"}</h1>

      {/* Seller Info */}
      <div className="flex items-center space-x-6 mb-8">
        <div className="w-24 h-24 bg-yellow-300 rounded-full border border-gray-300 flex items-center justify-center">
          <BsPersonFill className="text-gray-500 size-20" />
        </div>
        <div className="w-24 h-24 shadow-md border-2 border-gray-300 rounded-lg">
          <img
            src={sellerData.logo ? `${BASE_URL}${sellerData.logo}` : img}
            alt={sellerData.name || "Seller Logo"}
            className="w-full h-full object-contain rounded-lg"
          />
        </div>
      </div>

      {/* Personal & Company Info */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        <div>
          <h2 className="text-2xl font-bold mb-4">Personal Info</h2>
          <div className="space-y-4">
            {[
              { label: "Name", value: sellerData.name || "N/A" },
              { label: "Email", value: sellerData.email || "N/A" },
              { label: "Phone Number", value: sellerData.phone || "N/A" },
            ].map((info, index) => (
              <div key={index} className="p-4 bg-white border rounded-lg shadow-sm">
                <span className="block text-sm font-medium text-gray-600 mb-1">{info.label}</span>
                <p className="text-lg font-semibold text-gray-800">{info.value}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-bold mb-4">Company Info</h2>
          <div className="space-y-4">
            {[
              { label: "Company Name", value: sellerData.companyName || "N/A" },
              { label: "Location", value: sellerData.location || "N/A" },
              { label: "Company Email", value: sellerData.companyEmail || "N/A" },
            ].map((info, index) => (
              <div key={index} className="p-4 bg-white border rounded-lg shadow-sm">
                <span className="block text-sm font-medium text-gray-600 mb-1">{info.label}</span>
                <p className="text-lg font-semibold text-gray-800">{info.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Seller Products */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Seller Products</h2>
        {sellerProducts.length === 0 ? (
          <div className="text-center p-6 bg-white rounded-lg shadow">
            <img src={img} alt="No Products" className="w-52 mx-auto mb-4" />
            <p className="text-gray-700">No products found for this seller.</p>
          </div>
        ) : (
          <table className="w-full ">
            <thead>
              <tr>
                { ["Item No", "Product Code", "Name", "Stock", "Price", ""].map(
                  (header, index) => (
                    <th key={index} className="p-2 text-left text-green-500 text-sm font-bold">
                      {header}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
               {sellerProducts?.map((product, index) => (
                              <tr key={product.id || index} className="">
                                <td>
                                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                                    {index + 1}
                                  </div>
                                </td>
                                <td className="p-2">
  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
    {product.product_code}
  </div>
</td>
<td className="p-2">
  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
    {product.name}
  </div>
</td>
<td className="p-2">
  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
    {product.stock}
  </div>
</td>
<td className="p-2">
  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
    {product.price}
  </div>
</td>

                                {/* <td className="p-2">
                                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                                    {displayData(product.status, "status")}
                                  </div>
                                </td>
                                <td className="p-2">
                                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                                    {displayData(product.adminStatus, "admin status")}
                                  </div>
                                </td> */}
                                <td className="p-2">
                                  <Link to={`/admin/product-details/${product.id}`}
                                    className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100"
                                  >
                                    VIEW
                                  </Link>
                                </td>
                              </tr>
                            ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default SubAdminSellerView;
